var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkshop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    className: "appointment-types__type-svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 36.13 33.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.49,30.1a3.56,3.56,0,0,0-3.55-3.55h-7.1a3.31,3.31,0,0,0-.55.05,3.87,3.87,0,0,1,1.52,3.06v1.63h9.68Z",
    style: {
      fill: "none",
      stroke: "#9d9c9c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.29119708987907px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.84,26.6a3.31,3.31,0,0,0-.55-.05H4.19A3.56,3.56,0,0,0,.65,30.1v1.19h9.67V29.66A3.87,3.87,0,0,1,11.84,26.6Z",
    style: {
      fill: "none",
      stroke: "#9d9c9c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.29119708987907px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.08,3.23H20.94a2.4,2.4,0,0,1,0,.28V9.3a2.87,2.87,0,0,1-2.86,2.86H16.62a2.86,2.86,0,0,0,2.69,1.94h6.92L28.11,16a.57.57,0,0,0,1-.4V14.1a2.87,2.87,0,0,0,2.86-2.86V6.09A2.87,2.87,0,0,0,29.08,3.23Z",
    className: "appointment-types__type-svg-fill",
    style: {
      stroke: "#9d9c9c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.29119708987907px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.39,
    cy: 22.29,
    rx: 3.55,
    ry: 3.55,
    style: {
      fill: "none",
      stroke: "#9d9c9c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.29119708987907px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.29,30.1a3.56,3.56,0,0,1,3.55-3.55h7.1a3.56,3.56,0,0,1,3.55,3.55v1.19H21.29Z",
    style: {
      fill: "none",
      stroke: "#9d9c9c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.29119708987907px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.49,30.1a3.56,3.56,0,0,0-3.55-3.55h-7.1a3.31,3.31,0,0,0-.55.05,3.87,3.87,0,0,1,1.52,3.06v1.63h9.68Z",
    style: {
      fill: "none",
      stroke: "#9d9c9c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.29119708987907px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.74,
    cy: 22.29,
    rx: 3.55,
    ry: 3.55,
    style: {
      fill: "none",
      stroke: "#9d9c9c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.29119708987907px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.65,30.1a3.56,3.56,0,0,1,3.54-3.55h7.1a3.56,3.56,0,0,1,3.55,3.55v1.19H.65Z",
    style: {
      fill: "none",
      stroke: "#9d9c9c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.29119708987907px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.84,26.6a3.31,3.31,0,0,0-.55-.05H4.19A3.56,3.56,0,0,0,.65,30.1v1.19h9.67V29.66A3.87,3.87,0,0,1,11.84,26.6Z",
    style: {
      fill: "none",
      stroke: "#9d9c9c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.29119708987907px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.07,
    cy: 21.13,
    rx: 3.87,
    ry: 3.88,
    style: {
      fill: "none",
      stroke: "#9d9c9c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.29119708987907px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.42,29.66v3.1h9.29v0h3.1v-3.1a3.88,3.88,0,0,0-3.87-3.87H14.2a3.89,3.89,0,0,0-3.88,3.87v3.1h3.1Z",
    style: {
      fill: "none",
      stroke: "#9d9c9c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.29119708987907px"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.08,3.23H20.94a2.4,2.4,0,0,1,0,.28V9.3a2.87,2.87,0,0,1-2.86,2.86H16.62a2.86,2.86,0,0,0,2.69,1.94h6.92L28.11,16a.57.57,0,0,0,1-.4V14.1a2.87,2.87,0,0,0,2.86-2.86V6.09A2.87,2.87,0,0,0,29.08,3.23Z",
    className: "appointment-types__type-svg-fill"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-3)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.23,14.1,28.11,16a.57.57,0,0,0,1-.4V14.1a2.87,2.87,0,0,0,2.86-2.86V6.09a2.87,2.87,0,0,0-2.86-2.86H19.31a2.87,2.87,0,0,0-2.86,2.86v5.15a2.87,2.87,0,0,0,2.86,2.86Z",
    className: "appointment-types__type-svg-fill",
    style: {
      stroke: "#9d9c9c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.29119708987907px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.08,3.23H20.94a2.4,2.4,0,0,1,0,.28V9.3a2.87,2.87,0,0,1-2.86,2.86H16.62a2.86,2.86,0,0,0,2.69,1.94h6.92L28.11,16a.57.57,0,0,0,1-.4V14.1a2.87,2.87,0,0,0,2.86-2.86V6.09A2.87,2.87,0,0,0,29.08,3.23Z",
    style: {
      fill: "none",
      stroke: "#9d9c9c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.29119708987907px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.91,12.16,8,14a.57.57,0,0,1-1-.4V12.16A2.87,2.87,0,0,1,4.19,9.3V3.51A2.87,2.87,0,0,1,7.05.65H18.11A2.87,2.87,0,0,1,21,3.51V9.3a2.87,2.87,0,0,1-2.86,2.86Z",
    className: "appointment-types__type-svg-fill",
    style: {
      stroke: "#9d9c9c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.29119708987907px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.36,
    cy: 6.4,
    r: 0.32,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.29119708987907px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.58,
    cy: 6.4,
    r: 0.32,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.29119708987907px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.81,
    cy: 6.4,
    r: 0.32,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.29119708987907px"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkshop);
export default __webpack_public_path__ + "static/media/workshop.2197cb81aacdb6f5ecb9bda714137f16.svg";
export { ForwardRef as ReactComponent };